













import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import { IHeader } from '@/store/models/staff/IHeader';

@Component({})
export default class DataTable extends BaseComponent {
  @Prop({default: []}) headers: string[];
  @Prop({default: []}) data: any[];
  @Prop({default: false}) isItemView: boolean;

  get isFooterHidden() {
    return this.isItemView
  }

  get itemView() {
    if (this.isItemView) {
      return true;
    } else {
      return false;
    }
  }

  get mobileBreakpoint() {
    if (this.itemView) {
      return 3000;
    } else {
      return 100;
    }
  }

   get getTableColTitles() {
     return this.headers;
  //   let headers: IHeader[] = [];
  //   for (let item in this.headers) {
  //     const value: string = this.headers[item].charAt(0).toLowerCase() + this.headers[item].replace(/ /g, "").slice(1)
  //     let header = {} as IHeader;
  //     header.text = this.headers[item];
  //     header.value = value;
  //     header.align = "center";
  //     if (this.headers[item] !== "Claim Summary") {
  //       header.sortable = true;
  //     }
  //     if (this.headers[item] == "Claim Summary" || this.headers[item] == "Contact") {
  //       header.width = 200;
  //     }
  //     headers.push(header);
  //   }
  //   return headers;
   }

  openItem(item: any) {
    this.$emit("openItem", item)
  }
}
